(function () {
  var resizeObserver;

  function getHero() {
    return document.querySelector('.banner.bam-hub-hero');
  }

  function getCards() {
    return document.querySelector('.bam-hub-cards');
  }

  function syncBamHubCardsOverlap() {
    var hero = getHero();
    var cards = getCards();
    if (!hero || !cards) return;

    var box = hero.querySelector('.banner__box');
    if (!box) return;

    var heroSection = hero.closest('.shopify-section');
    var cardsSection = cards.closest('.shopify-section');
    if (heroSection) heroSection.classList.add('bam-hub-hero-section');
    if (cardsSection) cardsSection.classList.add('bam-hub-cards-section');

    // Match gradient width to the text box so it fades under the copy
    hero.style.setProperty('--banner-text-gradient-width', Math.ceil(box.getBoundingClientRect().width) + 'px');

    // Restore theme section spacing, then measure how far cards sit below the box
    if (cardsSection) {
      cardsSection.style.marginTop = '';
    }
    cards.style.setProperty('--hub-cards-overlap', '0px');

    // Force layout before measuring
    void cards.offsetHeight;

    var boxBottom = box.getBoundingClientRect().bottom;
    var cardsTop = cards.getBoundingClientRect().top;
    var pull = Math.round(cardsTop - boxBottom);

    if (pull > 0 && cardsSection) {
      cardsSection.style.marginTop = -pull + 'px';
      cards.style.setProperty('--hub-cards-overlap', pull + 'px');
      cards.classList.add('bam-hub-cards--anchored');
    }
  }

  function initBamHubCardsOverlap() {
    var hero = getHero();
    var cards = getCards();
    if (!hero || !cards) return;

    var box = hero.querySelector('.banner__box');
    if (!box) return;

    syncBamHubCardsOverlap();

    if (typeof ResizeObserver !== 'undefined') {
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = new ResizeObserver(syncBamHubCardsOverlap);
      resizeObserver.observe(hero);
      resizeObserver.observe(box);
      resizeObserver.observe(cards);
    } else {
      window.addEventListener('resize', syncBamHubCardsOverlap);
    }

    hero.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', syncBamHubCardsOverlap, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBamHubCardsOverlap);
  } else {
    initBamHubCardsOverlap();
  }

  window.addEventListener('load', syncBamHubCardsOverlap);
  document.addEventListener('shopify:section:load', function () {
    initBamHubCardsOverlap();
  });
  document.addEventListener('shopify:section:reorder', syncBamHubCardsOverlap);
})();
